<mat-card>
  <mat-card-title> Multimedia </mat-card-title>
  <mat-card-content>
    <form>
      <!-- ================= -->

      <div
        style="
          display: flex;
          border: solid 1px #dbdbdb;
          border-radius: 5px;
          overflow: auto;
        "
      >
        <div
          style="margin: 5px; width: 120px"
          *ngFor="let picture_item of main_object.pictures; let i = index"
        >
          <div style="margin: 5px">
            <div style="text-align: right">
              <button mat-icon-button (click)="fnRemove(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div
              *ngIf="picture_item.image_url"
              style="background-color: #000; border-radius: 5px"
            >
              <img
                style="
                  object-fit: contain;
                  height: 150px;
                  width: 100%;
                  margin: 0px 0px -6.5px 0px;
                "
                src="{{ picture_item.image_url }}"
              />
            </div>

            <div
              *ngIf="!picture_item.image_url"
              style="background-color: #000; border-radius: 5px"
            >
              <img
                style="
                  object-fit: contain;
                  height: 150px;
                  width: 100%;
                  margin: 0px 0px -6.5px 0px;
                "
                src="{{
                  'https://varscout.org/api/v1/files/public/?name=' +
                    picture_item.file_name
                }}"
              />
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Tipo</mat-label>
              <mat-select
                name="image_type_{{ i }}"
                [(ngModel)]="picture_item.tag"
              >
                <mat-option value="TU">Tubérculo</mat-option>
                <mat-option value="PL">Planta</mat-option>
                <mat-option value="FL">Flor</mat-option>
                <mat-option value="LE">Hoja</mat-option>
                <mat-option value="FR">Fruto</mat-option>
                <mat-option value="SP">Brote</mat-option>
                <mat-option value="SE">Semillas</mat-option>
                <mat-option value="ST">Tallo</mat-option>
                <mat-option value="OT">Otro</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <br />
      <!-- ============= -->
      <div style="border: solid 1px #dbdbdb; border-radius: 5px">
        <div div fxLayout="row">
          <input
            #myInput
            (change)="this.onFilechange($event)"
            class="form-control"
            type="file"
            id="formFile"
            name="uploadFileName"
          />
        </div>
        <div div fxLayout="row" style="padding: 5px">
          <mat-form-field appearance="outline">
            <mat-label>Tipo</mat-label>
            <mat-select name="image_type_new" [(ngModel)]="image_tag">
              <mat-option value="TU">Tubérculo</mat-option>
              <mat-option value="PL">Planta</mat-option>
              <mat-option value="FL">Flor</mat-option>
              <mat-option value="LE">Hoja</mat-option>
              <mat-option value="FR">Fruto</mat-option>
              <mat-option value="SP">Brote</mat-option>
              <mat-option value="SE">Semillas</mat-option>
              <mat-option value="ST">Tallo</mat-option>
              <mat-option value="OT">Otro</mat-option>
            </mat-select>
          </mat-form-field>

          <button
            mat-mini-fab
            color="primary"
            (click)="this.fnUploadImage()"
            type="button"
            style="margin: 5px"
          >
            <mat-icon>upload</mat-icon>
          </button>
        </div>
      </div>
      <!-- ================= -->

      <!-- ============= -->
    </form>
  </mat-card-content>
</mat-card>
